export default __webpack_public_path__ + "static/media/loadinggif.e5393adb.gif";